import { Box, Grid, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsPatternFill from "highcharts/modules/pattern-fill";
import { Options, SeriesOptionsType } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";
import {
  DaySummaryDto,
  TimelineDataStatus,
  TimelineDto,
} from "../../../../../services/timeline/timeline.model";
import { DateTime } from "luxon";
import ErrorBoundary from "../../../../../errorboundary.component";
import { convertSecondsToHHMM } from "../../../../admin/dailyemail/dailyemail.service";
import { TargetColors } from "../../../../landingpage/landingcards/goals-manager/components/goal-creator-card.component";
import { TimelineCardLegend } from "../../../../landingpage/landingcards/timeline/timeline.component";

HighchartsPatternFill(Highcharts);
let appName = "App";
//TODO show different colours online and focus 7E4BB7
// export const APP_DUMMY_COLOR = "#F39A8C";
export const APP_DUMMY_COLOR = "#7E4BB7";

export const timelineChartColors = {
  Offline: {
    color: {
      pattern: {
        path: {
          d: "M0,0 L30,24",
          strokeWidth: 10,
          fill: "#F5F6F9",
        },
        color: "#AAAFBB",
        width: 35,
        height: 30,
        opacity: 0.25,
      },
    },
  },
  Online: {
    color: "#AAAFBBBB",
  },
  App: {
    color: APP_DUMMY_COLOR + "BB",
  },
  AppFocus: {
    color: APP_DUMMY_COLOR,
  },
  Focus: {
    color: "#5D626FBB",
  },
  Goal: {
    color: "#29b6f6",
  },
  NoGoal: {
    color: "#29b6f633",
  },
};
interface AppTimelineChartProps {
  chartData: TimelineDto[];
  title: string;
  summary: DaySummaryDto;
  appName: string;
  today: boolean;
  minHour: number;
  maxHour: number;
  date: DateTime;
  showLegend: boolean;
}

export interface ChartDataEntry {
  value: number; //mins
  name: string;
  color: string;
}

export const AppTimelineChart = (props: AppTimelineChartProps): JSX.Element => {
  const [maxHour, setMaxHour] = useState<number>(props.maxHour);
  const [minHour, setMinHour] = useState<number>(props.minHour);

  const [chartOptions, setChartOptions] = useState<Options>({
    chart: {
      renderTo: "container",
      type: "bar",
      height: "70px",
      marginTop: 0,
      animation: false,
      // events: {
      //   click: function (e) {
      //     console.log(e);
      //   },
      // },
    },

    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    title: {
      text: undefined,
    },
    tooltip: {
      enabled: false,
      formatter: function () {
        return `${this.series.name}`;
      },
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: true,
      tickInterval: 60 * 1,
      // min: minHour * 60,
      // max: maxHour * 60,
      title: {
        text: "",
      },
      labels: {
        style: {
          textOverflow: "hidden",
        },
        enabled: true,
        formatter: function () {
          //   console.log(this);
          const min = props.minHour * 60;
          const tickVal = this.tick.pos - min;
          const hide = tickVal % (60 * 4) != 0;
          // console.log(
          //   "Time:",
          //   props.minHour,
          //   min,
          //   this.tick.pos,
          //   tickVal,
          //   hide
          // );
          if (hide) {
            return "";
          }
          const val = this.pos / 60;
          let time = val > 12 ? val - 12 : val;
          let tod = val >= 12 && this.pos !== 24 ? "pm" : "am";
          if (val === 0 || val === 24) {
            time = 12;
            tod = "am";
          }
          return `${time}${tod}`;
        },
      },
    },

    plotOptions: {
      series: {
        states: {
          inactive: {
            opacity: 1,
          },
          hover: {
            opacity: 0.9,
          },
        },
        // point: {
        //   events: {
        //     click: function (event) {
        //       console.log("point", this);
        //       // props.openDialog(true);
        //     },
        //     //   click: this.handleClick,
        //   },
        // },
        events: {
          click: function (event) {
            // console.log(this.name);
            // props.openDialog(parseInt(this.name) ?? 0, props.today);
          },
          //   click: this.handleClick,
        },
        stacking: "normal",
        dataLabels: {
          enabled: false,
          align: "right",
          y: -2,
          style: {
            color: "#050505",
            fontFamily: "Roboto, sans-serif",
            fontSize: "max(0.8vw,12px)",
            fontWeight: "light",
            boxShadow: "none",
            textOutline: "none",
            overflow: "ellipsis",
            position: "relative",
            top: "-6px",
          },
          //   formatter: function () {
          //     const self = this as any;
          //     const percent = self.percentage as number;
          //     if (percent < 15) {
          //       return "";
          //     }
          //     let minutes = this.y as number;
          //     const hours = Math.floor(minutes / 60);
          //     minutes = minutes % 60;
          //     const timeString =
          //       (hours != 0 ? hours + "h " : "") +
          //       (minutes != 0 ? minutes + "m " : "");
          //     return timeString;
          //   },
        },
      },
      bar: {
        grouping: false,
        pointWidth: 24,
        groupPadding: 0,
        // point: {
        //   events: {
        //     click: function (event) {
        //       console.log(this);
        //     },
        //   },
        // },
      },
    },
  });

  const [legendItems, setLegendItems] = useState<LegendItem[]>([]);

  const [noDataOverlay, setNoDataOverlay] = useState<boolean>(false);

  const generateLegend = () => {
    const list = [
      {
        name: "Offline",
        color:
          "repeating-linear-gradient(45deg,#AAAFBB,#AAAFBB 10px,#fff 10px,#fff 20px)",
        index: 0,
        pattern: true,
      },
      { name: "Fragmented", color: "#AAAFBBBB", index: 1, pattern: false },
      { name: "Focused", color: "#5D626FBB", index: 2, pattern: false },
      {
        name: `${props.appName}`,
        color: APP_DUMMY_COLOR,
        index: 3,
        pattern: false,
      },
    ];
    setLegendItems(list);
  };

  useEffect(() => {
    generateLegend();
  }, [props.appName]);

  useEffect(() => {
    if (props.chartData.length > 0) {
      const cdata: TimelineDto[] = JSON.parse(JSON.stringify(props.chartData));
      const series = cdata.reverse().map((data) => {
        const color =
          data.status === TimelineDataStatus.APP
            ? data.focus && !data.focusBreak
              ? timelineChartColors.AppFocus.color
              : timelineChartColors.App.color
            : timelineChartColors[data.status].color;
        return {
          data: [data.time.duration / 60],
          name: data.hour,
          color: color,
          //   cursor: `${data.status !== "Offline" ? "pointer" : "normal"}`,
          borderRadiusTopLeft: "",
          borderRadiusTopRight: "",
          borderRadiusBottomLeft: "",
          borderRadiusBottomRight: "",
        };
        // appName = props.appName;
      });
      // if (series.length > 0) {
      //   series[0].borderRadiusTopLeft = "50%";
      //   series[0].borderRadiusTopRight = "50%";
      //   series[series.length - 1].borderRadiusBottomLeft = "50%";
      //   series[series.length - 1].borderRadiusBottomRight = "50%";
      // }
      chartOptions.series = series as unknown as SeriesOptionsType[];

      setChartOptions({ ...chartOptions });
    }
  }, [props.chartData]);

  useEffect(() => {
    setNoDataOverlay(!props.chartData || props.chartData.length == 0);
  }, [props.chartData]);

  useEffect(() => {
    const tempOptions = { ...chartOptions } as any;
    tempOptions.yAxis.min = props.minHour * 60;
    tempOptions.yAxis.max = props.maxHour * 60;
    tempOptions.yAxis.labels.formatter = function () {
      //   console.log(this);
      const min = props.minHour * 60;
      const tickVal = this.tick.pos - min;
      const hide = tickVal % (60 * 4) != 0;
      // console.log("NewTime:", props.minHour, min, this.tick.pos, tickVal, hide);
      if (hide) {
        return "";
      }
      const val = this.pos / 60;
      let time = val > 12 ? val - 12 : val;
      let tod = val >= 12 && this.pos !== 24 ? "pm" : "am";
      if (val === 0 || val === 24) {
        time = 12;
        tod = "am";
      }
      return `${time}${tod}`;
    };

    setChartOptions(tempOptions);
    // console.log("min hour ", props.minHour);
    // console.log("max hour ", props.maxHour);
  }, [props.minHour, props.maxHour]);

  return (
    <>
      {noDataOverlay ? (
        <Box
          margin="2% auto"
          borderRadius="8px"
          height="70px"
          textAlign="center"
          width="100%"
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          border="1px dashed #AAAFBB"
        >
          <Typography variant="h6Light" margin="auto" width="100%">
            No data available
          </Typography>
        </Box>
      ) : (
        <ErrorBoundary>
          <Box
            borderRadius="8px"
            justifyContent="center"
            bgcolor="#FFFFFF"
            padding={"5px"}
            // paddingTop={"2px"}
            sx={{ marginTop: "0.3%" }}
          >
            {/* <Stack direction={"row"}> */}

            {/* <Typography variant="body1Bold">{props.title}</Typography> */}
            <Grid container sx={{ mb: 1 }}>
              <Grid item md={6}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body1Bold">
                    {props.date.toFormat("LLL dd, yyyy")}
                  </Typography>
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    (
                    <span style={{ color: TargetColors.time }}>
                      Time: {convertSecondsToHHMM(props.summary.time)}
                    </span>
                    {" | "}
                    <span style={{ color: TargetColors.focus }}>
                      Focus: {convertSecondsToHHMM(props.summary.focus)}
                    </span>
                    {" | "}
                    <span style={{ color: TargetColors.activities }}>
                      Switch: {props.summary.activities}
                    </span>
                    {/* <span style={{ color: APP_DUMMY_COLOR }}>
                      App: {props.summary.activities}
                    </span> */}
                    )
                  </Typography>
                </Box>
              </Grid>
              {props.showLegend ? (
                <Grid item md={6}>
                  <TimelineCardLegend legendItems={legendItems} />
                </Grid>
              ) : (
                ""
              )}
            </Grid>

            <HighchartsReact
              highcharts={Highcharts}
              options={chartOptions}
              allowChartUpdate={true}
              updateArgs={[true, true, true]}
            />
            {/* </Stack> */}
          </Box>
        </ErrorBoundary>
      )}
    </>
  );
};

type LegendItem = {
  name: string;
  color: string;
  index: number;
  pattern: boolean;
};

const LEGEND_ITEMS: LegendItem[] = [
  {
    name: "Offline",
    color:
      "repeating-linear-gradient(45deg,#AAAFBB,#AAAFBB 10px,#fff 10px,#fff 20px)",
    index: 0,
    pattern: true,
  },
  { name: "Fragmented", color: "#AAAFBBBB", index: 1, pattern: false },
  { name: "Focused", color: "#5D626FBB", index: 2, pattern: false },
  // { name: "Future", color: "#FFFFFFFF", index: 4, pattern: false },
  { name: `${appName}`, color: APP_DUMMY_COLOR, index: 3, pattern: false },
  // {
  //   name: "App - Fragmented",
  //   color: APP_DUMMY_COLOR + "BB",
  //   index: 4,
  //   pattern: false,
  // },
];
